(() => {
  if (window.__mpCartDrawerEnhancementsBound) return;
  window.__mpCartDrawerEnhancementsBound = true;

  const rootUrl = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const taxRoleStorageKey = 'mp_customer_type_v2';

  const currentTaxRole = () => {
    const apiRole = window.MiniPowerTax && typeof window.MiniPowerTax.getRole === 'function'
      ? window.MiniPowerTax.getRole()
      : '';
    if (apiRole === 'private' || apiRole === 'business') return apiRole;
    try {
      const storedRole = window.localStorage.getItem(taxRoleStorageKey);
      if (storedRole === 'private' || storedRole === 'business') return storedRole;
    } catch (error) {
      console.warn('[Mini Power Cart] Customer type could not be read.', error);
    }
    return 'private';
  };

  const updateTaxRoleControls = (role = currentTaxRole()) => {
    document.querySelectorAll('[data-mp-cart-tax-role]').forEach((button) => {
      button.setAttribute('aria-pressed', button.dataset.mpCartTaxRole === role ? 'true' : 'false');
    });
    document.querySelectorAll('[data-mp-cart-tax-fact]').forEach((fact) => {
      fact.hidden = fact.dataset.mpCartTaxFact !== role;
    });
  };

  const setTaxRoleBusy = (busy) => {
    document.querySelectorAll('[data-mp-cart-tax-choice]').forEach((group) => {
      group.setAttribute('aria-busy', busy ? 'true' : 'false');
    });
    document.querySelectorAll('[data-mp-cart-tax-role]').forEach((button) => {
      button.disabled = busy;
    });
  };

  let scalaPlacementFrame = 0;

  const styleScalaButton = (host) => {
    const shadowRoot = host && host.shadowRoot;
    if (!shadowRoot) return;

    let style = shadowRoot.querySelector('[data-mp-scala-button-style]');
    if (!style) {
      style = document.createElement('style');
      style.setAttribute('data-mp-scala-button-style', '');
      style.textContent = `
        #scala-button,
        button {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 100% !important;
          min-height: 48px !important;
          box-sizing: border-box !important;
          border: 0 !important;
          border-radius: 10px !important;
          padding: 11px 18px !important;
          background: #008edc !important;
          color: #fff !important;
          font-family: "Open Sans", Arial, Helvetica, sans-serif !important;
          font-size: 14px !important;
          font-weight: 700 !important;
          letter-spacing: .1px !important;
          line-height: 1.25 !important;
          text-align: center !important;
          text-transform: none !important;
        }

        #scala-button:hover,
        button:hover {
          background: #0078bb !important;
          color: #fff !important;
        }
      `;
      shadowRoot.append(style);
    }
  };

  const syncScalaCartButton = () => {
    const drawer = document.getElementById('t4s-mini_cart');
    const hosts = Array.from(document.querySelectorAll('scala-cart-button'));
    if (!hosts.length) return;

    if (!drawer) {
      hosts.forEach((host) => {
        host.hidden = true;
      });
      return;
    }

    const host = drawer.querySelector('scala-cart-button') || hosts[0];
    hosts.forEach((candidate) => {
      candidate.hidden = candidate !== host;
    });
    host.hidden = false;
    host.classList.add('mp-scala-drawer-button');

    const summary = drawer.querySelector('[data-mp-cart-summary]');
    const vorkasse = summary && summary.querySelector('.mp-cart-vorkasse');
    const bottom = drawer.querySelector('.t4s-drawer__bottom');
    const checkout = bottom && bottom.querySelector('.t4s-btn__checkout');

    if (vorkasse) {
      if (vorkasse.nextElementSibling !== host) vorkasse.after(host);
      host.classList.add('mp-scala-drawer-button--summary');
    } else if (bottom) {
      if (host.parentElement !== bottom || host.nextElementSibling !== checkout) {
        if (checkout) bottom.insertBefore(host, checkout);
        else bottom.append(host);
      }
      host.classList.remove('mp-scala-drawer-button--summary');
    }

    styleScalaButton(host);
  };

  const queueScalaCartButtonSync = () => {
    if (scalaPlacementFrame) return;
    scalaPlacementFrame = window.requestAnimationFrame(() => {
      scalaPlacementFrame = 0;
      syncScalaCartButton();
    });
  };

  const scalaObserver = new MutationObserver((mutations) => {
    const needsSync = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).concat(Array.from(mutation.removedNodes)).some((node) =>
        node.nodeType === 1 && (
          node.matches?.('scala-cart-button, #t4s-mini_cart, [data-mp-cart-summary]') ||
          node.querySelector?.('scala-cart-button, #t4s-mini_cart, [data-mp-cart-summary]')
        )
      )
    );
    if (needsSync) queueScalaCartButtonSync();
  });

  if (document.documentElement) {
    scalaObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
  const money = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: currency || 'EUR'
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return ((Number(cents) || 0) / 100).toFixed(2) + ' ' + (currency || 'EUR');
    }
  };

  const setBusy = (button, busy, busyLabel) => {
    if (!button) return;
    if (busy) {
      button.dataset.mpOriginalLabel = button.textContent;
      button.textContent = busyLabel;
      button.disabled = true;
    } else {
      button.textContent = button.dataset.mpOriginalLabel || button.textContent;
      button.disabled = false;
      delete button.dataset.mpOriginalLabel;
    }
  };

  const setFeedbackNode = (node, message, state) => {
    if (!node) return;
    node.textContent = message;
    node.classList.toggle('is-success', state === 'success');
    node.classList.toggle('is-error', state === 'error');
  };

  const setFeedback = (selector, message, state) => {
    setFeedbackNode(document.querySelector(selector), message, state);
  };

  const announce = (message) => {
    const node = document.querySelector('[data-mp-cart-live]');
    if (node) node.textContent = message;
  };

  const parseError = (data, fallback) =>
    (data && (data.description || data.message)) || fallback;

  const postCart = async (endpoint, payload) => {
    const response = await fetch(rootUrl() + endpoint, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(parseError(data, 'Die Änderung konnte nicht gespeichert werden.'));
    return data;
  };

  const patchDrawer = (html) => {
    if (!html) return false;
    const current = document.getElementById('t4s-mini_cart');
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const fresh = parsed.getElementById('t4s-mini_cart');
    if (!current || !fresh) return false;

    const mountingWasOpen = Boolean(current.querySelector('[data-mp-mounting-details]')?.open);
    const scalaButton = current.querySelector('scala-cart-button');
    const currentSummary = current.querySelector('[data-mp-cart-summary]');
    const currentBottom = current.querySelector('.t4s-drawer__bottom');
    if (scalaButton && currentSummary?.contains(scalaButton) && currentBottom) {
      currentBottom.prepend(scalaButton);
    }
    const selectors = [
      '[data-cart-calc-shipping]',
      '[data-cart-items]',
      '[data-mp-mounting-slot]',
      '[data-mp-cart-summary]',
      '[data-mp-cart-logistics]',
      '[data-cart-discounts]',
      '[data-cart-prices]',
      '[data-mp-payment-trust]'
    ];

    selectors.forEach((selector) => {
      const currentNode = current.querySelector(selector);
      const freshNode = fresh.querySelector(selector);
      if (currentNode && freshNode) currentNode.replaceWith(freshNode);
      else if (currentNode && !freshNode) currentNode.remove();
    });

    const mounting = current.querySelector('[data-mp-mounting-details]');
    if (mounting) mounting.open = mountingWasOpen;
    updateTaxRoleControls();
    queueScalaCartButtonSync();
    return true;
  };

  let drawerRefreshRequest = 0;
  const refreshDrawerFromServer = async () => {
    const requestId = ++drawerRefreshRequest;
    try {
      const url = new URL(rootUrl(), window.location.origin);
      url.searchParams.set('sections', 'mini_cart');
      url.searchParams.set('_mp_cart', Date.now().toString());
      const response = await fetch(url.href, { cache: 'no-store' });
      const sections = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error('Der Warenkorb konnte nicht aktualisiert werden.');
      if (requestId !== drawerRefreshRequest) return;
      if (!patchDrawer(sections && sections.mini_cart)) {
        throw new Error('Der Warenkorb konnte nicht neu dargestellt werden.');
      }
    } catch (error) {
      console.warn('[Mini Power Cart] Cart drawer could not be refreshed.', error);
    }
  };

  const updateHeader = (cart) => {
    if (!cart) return;
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = cart.item_count;
      node.classList.toggle('t4s-op-0', cart.item_count === 0);
    });
    document.querySelectorAll('[data-cart-tt-price]').forEach((node) => {
      node.textContent = money(cart.total_price, cart.currency);
    });
    const saving = Math.floor((Number(cart.total_price) || 0) * 3 / 100);
    document.querySelectorAll('[data-mp-vorkasse-saving]').forEach((node) => {
      node.textContent = '− ' + money(saving, cart.currency);
    });
  };

  const cartHasCodeDiscount = (cart, code) => {
    const normalized = String(code || '').trim().toLowerCase();
    const applications = [...(cart.cart_level_discount_applications || [])];
    (cart.items || []).forEach((item) => {
      (item.discounts || []).forEach((discount) => applications.push(discount));
      (item.line_level_discount_allocations || []).forEach((allocation) => {
        if (allocation.discount_application) applications.push(allocation.discount_application);
      });
    });
    return applications.some((application) => {
      const title = String(application.title || application.code || '').trim().toLowerCase();
      return title === normalized;
    });
  };

  const discountCodeStatus = (cart, code) => {
    const normalized = String(code || '').trim().toLowerCase();
    const entry = (cart.discount_codes || []).find((discount) =>
      String(discount.code || '').trim().toLowerCase() === normalized
    );
    if (!entry) return 'unknown';
    if (entry.applicable === false) return 'rejected';
    if (entry.applicable === true) return 'accepted';
    return 'unknown';
  };

  const getCart = async () => {
    const response = await fetch(rootUrl() + 'cart.js', {
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Der Warenkorbstand konnte nicht gelesen werden.');
    return response.json();
  };

  let cartSummaryRequest = 0;
  const refreshHeaderFromCart = async () => {
    const requestId = ++cartSummaryRequest;
    try {
      const cart = await getCart();
      if (requestId === cartSummaryRequest) updateHeader(cart);
    } catch (error) {
      console.warn('[Mini Power Cart] Cart summary could not be refreshed.', error);
    }
  };

  const bindThemeCartEvents = () => {
    if (!window.jQuery_T4NT) return;
    window.jQuery_T4NT(document)
      .off('add:cart:success.mpCartSavings cart:updated.mpCartSavings')
      .on('add:cart:success.mpCartSavings cart:updated.mpCartSavings', () => {
        refreshHeaderFromCart().then(refreshDrawerFromServer);
        window.setTimeout(bindThemeCartEvents, 0);
      });
  };
  bindThemeCartEvents();

  const commonPayload = () => ({
    sections: ['mini_cart'],
    sections_url: window.location.pathname
  });

  const applyDiscount = async (button) => {
    const form = button && button.closest('[data-mp-discount-form]');
    const input = form && form.querySelector('[data-mp-discount-code]');
    const feedback = form && form.querySelector('[data-mp-discount-feedback]');
    const isCartPage = Boolean(form && form.hasAttribute('data-mp-cart-page-discount'));
    const code = input ? input.value.trim() : '';

    if (!code) {
      setFeedbackNode(feedback, 'Bitte geben Sie einen Gutscheincode ein.', 'error');
      input?.focus();
      return;
    }

    setBusy(button, true, 'Prüfen …');
    setFeedbackNode(feedback, 'Gutscheincode wird geprüft …');
    try {
      const updateResult = await postCart('cart/update.js', { discount: code, ...commonPayload() });
      const cart = await getCart();
      const hasVisibleDiscount = cartHasCodeDiscount(cart, code) && Number(cart.total_discount) > 0;
      const codeStatus = discountCodeStatus(cart, code);
      const accepted = hasVisibleDiscount || codeStatus === 'accepted';
      const rejectedMessage =
        'Dieser Gutscheincode gilt nicht für die aktuellen Artikel oder Voraussetzungen. Bitte prüfen Sie Aktionsprodukte, Mindestbestellwert und Gültigkeit.';
      const pendingMessage =
        'Der Gutscheincode wurde gespeichert. Shopify zeigt für diesen Warenkorb noch keinen Preisabzug; die endgültige Gültigkeit wird im Checkout bestätigt.';

      if (isCartPage) {
        updateHeader(cart);
        if (hasVisibleDiscount) {
          setFeedbackNode(
            feedback,
            'Gutscheincode angewendet. Aktuell berücksichtigt: − ' + money(cart.total_discount, cart.currency),
            'success'
          );
          announce('Der Gutscheincode wurde angewendet.');
          window.setTimeout(() => window.location.reload(), 350);
        } else if (accepted) {
          setFeedbackNode(feedback, pendingMessage, 'success');
          announce('Der Gutscheincode wurde gespeichert.');
        } else {
          setFeedbackNode(feedback, rejectedMessage, 'error');
          announce('Der Gutscheincode ist für den aktuellen Warenkorb nicht gültig.');
        }
        return;
      }

      if (!patchDrawer(updateResult.sections && updateResult.sections.mini_cart)) {
        throw new Error('Der Warenkorb konnte nicht neu dargestellt werden.');
      }
      updateHeader(cart);
      const refreshedForm = document.querySelector('#t4s-mini_cart [data-mp-discount-form]');
      const refreshedInput = refreshedForm && refreshedForm.querySelector('[data-mp-discount-code]');
      const refreshedFeedback = refreshedForm && refreshedForm.querySelector('[data-mp-discount-feedback]');
      if (refreshedInput) refreshedInput.value = code;

      if (hasVisibleDiscount) {
        setFeedbackNode(
          refreshedFeedback,
          'Gutscheincode angewendet. Aktuell berücksichtigt: − ' + money(cart.total_discount, cart.currency),
          'success'
        );
        announce('Der Gutscheincode wurde angewendet.');
      } else if (accepted) {
        setFeedbackNode(refreshedFeedback, pendingMessage, 'success');
        announce('Der Gutscheincode wurde gespeichert.');
      } else {
        setFeedbackNode(refreshedFeedback, rejectedMessage, 'error');
        announce('Der Gutscheincode ist für den aktuellen Warenkorb nicht gültig.');
      }
    } catch (error) {
      setFeedbackNode(feedback, error.message, 'error');
    } finally {
      setBusy(button, false);
    }
  };

  const addMounting = async (button) => {
    const variantId = button && button.dataset.mpCartAdd;
    if (!variantId) return;
    setBusy(button, true, 'Wird hinzugefügt …');
    setFeedback('[data-mp-mounting-feedback]', 'Produkt wird hinzugefügt …');
    try {
      const result = await postCart('cart/add.js', {
        items: [{ id: variantId, quantity: 1 }],
        ...commonPayload()
      });
      if (!patchDrawer(result.sections && result.sections.mini_cart)) {
        throw new Error('Der Warenkorb konnte nicht neu dargestellt werden.');
      }
      const cart = await getCart();
      updateHeader(cart);
      announce('Das Produkt wurde dem Warenkorb hinzugefügt.');
    } catch (error) {
      setFeedback('[data-mp-mounting-feedback]', error.message, 'error');
    } finally {
      setBusy(button, false);
    }
  };

  const applyTaxRole = async (button) => {
    const nextRole = button && button.dataset.mpCartTaxRole;
    if (nextRole !== 'private' && nextRole !== 'business') return;

    const api = window.MiniPowerTax;
    if (!api || typeof api.setRole !== 'function') {
      announce('Die Steuerart konnte noch nicht geändert werden. Bitte versuchen Sie es erneut.');
      return;
    }

    setTaxRoleBusy(true);
    updateTaxRoleControls(nextRole);
    const status = document.querySelector('[data-mp-cart-tax-status]');
    if (status) status.textContent = 'Warenkorb und Steuerart werden aktualisiert.';
    try {
      await api.setRole(nextRole);
      updateTaxRoleControls(nextRole);
      if (status) {
        status.textContent = nextRole === 'business'
          ? 'Geschäftskunde mit 19 Prozent Mehrwertsteuer ausgewählt.'
          : 'Privatkunde mit 0 Prozent Mehrwertsteuer für entsprechend begünstigte Photovoltaikprodukte ausgewählt.';
      }
    } catch (error) {
      updateTaxRoleControls(currentTaxRole());
      announce(error instanceof Error ? error.message : 'Die Steuerart konnte nicht aktualisiert werden.');
    } finally {
      setTaxRoleBusy(false);
    }
  };

  document.addEventListener('click', (event) => {
    const taxRoleButton = event.target.closest('[data-mp-cart-tax-role]');
    if (taxRoleButton) {
      event.preventDefault();
      applyTaxRole(taxRoleButton);
      return;
    }

    const closeButton = event.target.closest('[data-mp-cart-close]');
    if (closeButton) {
      event.preventDefault();
      document.querySelector('#t4s-mini_cart [data-drawer-close]')?.click();
      return;
    }

    const discountButton = event.target.closest('[data-mp-discount-apply]');
    if (discountButton) {
      event.preventDefault();
      applyDiscount(discountButton);
      return;
    }

    const mountingButton = event.target.closest('[data-mp-cart-add]');
    if (mountingButton) {
      event.preventDefault();
      addMounting(mountingButton);
    }
  });

  document.addEventListener('mp:tax-role-changed', (event) => {
    updateTaxRoleControls(event.detail && event.detail.role);
  });

  ['cart:refresh', 'cart:refresh:opend', 'shopify:section:load'].forEach((eventName) => {
    document.addEventListener(eventName, () => {
      if (eventName !== 'shopify:section:load') refreshHeaderFromCart();
      window.requestAnimationFrame(() => {
        updateTaxRoleControls();
        queueScalaCartButtonSync();
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      updateTaxRoleControls();
      queueScalaCartButtonSync();
    }, { once: true });
  } else {
    updateTaxRoleControls();
    queueScalaCartButtonSync();
  }

  window.addEventListener('load', queueScalaCartButtonSync, { once: true });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || !event.target.matches('[data-mp-discount-code]')) return;
    event.preventDefault();
    const form = event.target.closest('[data-mp-discount-form]');
    const button = form && form.querySelector('[data-mp-discount-apply]');
    if (button) applyDiscount(button);
  });
})();

